import {ToolRenderer} from '../tool/Tool'
import {pairedToolCallToToolProps} from '../../../utils/events/tool-helpers'
import type {ToolCallItem} from '../../../types/events'

export function ToolCall({
  item,
  isInGroup,
  isEditGroup,
  mcpToolNameMappings,
}: {
  item: ToolCallItem
  isInGroup?: boolean
  isEditGroup?: boolean
  mcpToolNameMappings?: Record<string, string>
}) {
  const {name, args, delta} = pairedToolCallToToolProps(item.toolCall)
  return (
    <ToolRenderer
      name={name}
      delta={delta}
      args={args}
      isInGroup={isInGroup}
      isEditGroup={isEditGroup}
      mcpToolNameMappings={mcpToolNameMappings}
    />
  )
}
